import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';

import NewOverlayList from '/@/components/new-overlay-list';
import { _ } from '/@/locale';
import { isMobile } from '/@/utils';
import styles from './styles.module.css';
@autobind
export default class InteractiveFieldOverlayList extends Component {
    static propTypes = {
        field: PropTypes.object.isRequired,
    };

    state = {
        collapsed: true,
    };

    handleCollapseClick(event) {
        event.stopPropagation();
        this.setState((state) => ({
            collapsed: !state.collapsed,
        }));
    }

    render() {
        const { collapsed } = this.state;

        const empty = (this.props.field.mapValues || []).length === 0;

        if (isMobile()) return null;

        return (
            <div className={classNames(styles.interactive, { [styles.collapsed]: collapsed })}>
                <div className={styles.header} onClick={this.handleCollapseClick}>
                    <div className={styles.title}>
                        <div className={styles.label}>{_('Enfermedades, plagas y malezas')}</div>
                        <i className='material-icons'>{collapsed ? 'expand_more' : 'expand_less'}</i>
                    </div>
                    {!collapsed && (
                        <div className={styles.description}>
                            {empty
                                ? _('Estamos procesando la información histórica para tu lote.')
                                : _('Este lote registra los siguientes valores para cada capa de información:')}
                        </div>
                    )}
                </div>
                {!empty && !collapsed && (
                    <div className={styles.overlays}>
                        <NewOverlayList field={this.props.field} />
                    </div>
                )}
            </div>
        );
    }
}
